
import { types, actions } from './requests'
export const GETCOLLECTIONSFULL_TYPES = {
    ...types('GETCOLLECTIONSFULL'),
}
export const GETCOLLECTIONSFULL_ACTIONS = {
    ...actions('GETCOLLECTIONSFULL'),
}